import request from '@/utils/request'
import { formatParam } from '@/utils/tool'

// 全局获取sizeAll
export const getAllSizeRequest = async (url, params) => {
  const [res1, res2] = await Promise.all([
    await request(`${url}?${formatParam(params)}`, {
      method: 'GET'
    }),
    await request(`${url}?${formatParam(params)}&isForCount=true&autoCount=true`, {
      method: 'GET'
    })
  ])
  const { sizeAll, pageCount, data } = res2
  res1.sizeAll = (sizeAll || sizeAll === 0) ? sizeAll : data.sizeAll
  res1.pageCount = pageCount
  return res1
}

// 活动列表
export function getPlanList (params): any {
  return getAllSizeRequest('/saas/plan/activity/list', params)
}

// 加载活动计划详情
export function getLoad (id): any {
  return request(`/saas/plan/activity/load?id=${id}`, {
    method: 'GET'
  })
}

// 活动报名
export function enrol (params, planId): any {
  return request(`/saas/plan/activity/enrol?planId=${planId}`, {
    method: 'POST',
    data: { liveProducts: params, planId }
  })
}

// 取消报名
export function cancelEnrol (id): any {
  return request(`/saas/plan/activity/cancelEnrol?planId=${id}`, {
    method: 'PUT'
  })
}

// 获取报名商品列表
export function getlistSaasProduct (params): any {
  return getAllSizeRequest('/saas/plan/activity/listSaasProduct', params)
}
